import socialNetworks, { MD_SUPPORT_EMAIL } from '#shared/data/socialNetworks';

export function useBasicSEO() {
  const runtimeConfig = useRuntimeConfig();
  const siteUrl = runtimeConfig.public.siteUrl;

  useHead({
    meta: [
      { 'http-equiv': 'x-ua-compatible', content: 'IE=edge' },
      { name: 'theme-color', content: '#101317' },
      { name: 'apple-mobile-web-app-status-bar-style', content: '#101317' },
      { name: 'full-screen', content: 'yes' },
      { name: 'mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'apple-mobile-web-app-title', content: 'MaxDuel' },
    ],
  });

  useSeoMeta({
    ogType: 'website',
    ogSiteName: 'MaxDuel',
    ogUrl: siteUrl,
    title: 'MaxDuel | The Ultimate Player vs Player Platform',
    ogTitle: 'MaxDuel | The Ultimate Player vs Player Platform',
    description:
      'MaxDuel is the ultimate Player vs Player (PvP) game platform where you compete in original games of skill for real cash prizes. Experience PvP versions of your favorite games and play against others in a "winner take all" format to take the entire Prize Pot!',
    ogDescription:
      'MaxDuel is the ultimate Player vs Player (PvP) game platform where you compete in original games of skill for real cash prizes. Experience PvP versions of your favorite games and play against others in a "winner take all" format to take the entire Prize Pot!',
    ogImage: `${siteUrl}/images/banners/maxduel.webp`,
  });

  useSchemaOrg([
    defineWebSite({
      name: 'MaxDuel',
      url: `${siteUrl}/`,
      headline: 'MaxDuel | The Ultimate Player vs Player Platform',
      description:
        'MaxDuel is the ultimate Player vs Player (PvP) game platform where you compete in original games of skill for real cash prizes. Experience PvP versions of your favorite games and play against others in a "winner take all" format to take the entire Prize Pot!',
      inLanguage: 'en',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    }),
    defineOrganization({
      name: 'MaxDuel',
      url: 'https://maxduel.com',
      logo: 'https://maxduel.com/images/logo.webp',
      sameAs: socialNetworks.map((social) => social.to),
      contactPoint: {
        '@type': 'ContactPoint',
        email: MD_SUPPORT_EMAIL,
        contactType: 'customer service',
      },
    }),
  ]);
}
